import Logger from './logger.js';

// main startup routine that renders app
const startup = async (component, props = {}) => {
  const {default: render} = await import('./render.jsx');
  return render(props);
};

export default startup;
